import './nav-toggle.scss';

export default class NavToggle {
    static render(label: string = '', modifier: string = '', cssClass: string = '', attr: string = ''): string {
        return '<button class="nav-toggle ' + modifier + ' ' + cssClass + '" ' + attr + '><span class="nav-toggle__label">' + label + '</span><span class="nav-toggle__burger"><span class="nav-toggle__burger-mid"></span></span></button>';
    }
}
